<template>
  <div class="message-response">
    <span v-html="converter.makeHtml(message.options.content)"></span>
  </div>
</template>

<script>
    import { Message } from '@/bot-engine.es5.js'
    import showdown from 'showdown'

    export default {
      name: 'Bubble',
      props: {
        message: {
          type: Message
        }
      },
      data() {
        return {
          converter: new showdown.Converter()
        }
      },
      computed: {
        messageType() {
          return this.message.type == 'response' ? "sent" : "received";
        },
      }
    }
</script>

<style scoped>
@keyframes fromright {
  0%   {left:200%; top:0px;}
  75%  {left:10%; top:0px;}
  100% {left:0px; top:0px;}
}

  .message-response {
    animation-name: fromright;
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
    position: relative;
  }
</style>